// @flow

import * as React from "react";
import type { ModalLauncherRenderProps } from "../ModalLauncher/ModalLauncher";
import { Button, ModalLauncher } from "../../index";
import styles from "./ConfirmationModalLauncher.scss";
import ButtonsGroup from "../ButtonsGroup";

type ConfirmationModalProps = {
  confirmButtonText: React.Node,
  declineButtonText: React.Node,
  isConfirmButtonLoading: boolean,
  isDeclineButtonLoading: boolean,
  isConfirmButtonDisabled: boolean,
  isDeclineButtonDisabled: boolean,
  isConfirmButtonHidden: boolean,
  isDeclineButtonHidden: boolean,
  confirmAction: ModalLauncherRenderProps => void,
  declineAction: ModalLauncherRenderProps => void,
  trigger: ModalLauncherRenderProps => React.Node,
  content: ModalLauncherRenderProps => React.Node
};

const ConfirmationModalLauncher = ({
  confirmButtonText,
  declineButtonText,
  isConfirmButtonDisabled,
  isDeclineButtonDisabled,
  isConfirmButtonLoading,
  isDeclineButtonLoading,
  isConfirmButtonHidden,
  isDeclineButtonHidden,
  confirmAction,
  declineAction,
  trigger,
  content
}: ConfirmationModalProps) => (
  <ModalLauncher
    trigger={trigger}
    content={({ open, close }) => {
      const modalLauncherRenderProps = { open, close };

      return (
        <div className={styles.contentContainer}>
          <div className={styles.textContainer}>{content(modalLauncherRenderProps)}</div>
          <ButtonsGroup>
            {!isConfirmButtonHidden && (
              <Button
                size="small"
                onClick={() => confirmAction(modalLauncherRenderProps)}
                isDisabled={isConfirmButtonDisabled}
                isLoading={isConfirmButtonLoading}
              >
                {confirmButtonText}
              </Button>
            )}
            {!isDeclineButtonHidden && (
              <Button
                size="small"
                onClick={() => declineAction(modalLauncherRenderProps)}
                isDisabled={isDeclineButtonDisabled}
                isLoading={isDeclineButtonLoading}
              >
                {declineButtonText}
              </Button>
            )}
          </ButtonsGroup>
        </div>
      );
    }}
    wide
  />
);

export default ConfirmationModalLauncher;
